import { Product } from "@1games-ru/region-shared/dist/backend/requests/shop";
import { ShopProductCategory } from "@1games-ru/region-shared/dist/enums/shop/shop-product";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NavItemType } from "@/domains/shop/constants/navItemType";

export function useNavList(list?: Product[]): NavItemType[] {
  const { t } = useTranslation("shop");

  return useMemo<NavItemType[]>(() => {
    if (!list?.length) return [];

    const listAll = [
      { id: ShopProductCategory.Product, text: t("category.products"), isActive: false },
      { id: ShopProductCategory.Household, text: t("category.household"), isActive: false },
      { id: ShopProductCategory.Tech, text: t("category.technic"), isActive: false },
      { id: ShopProductCategory.Pills, text: t("category.pills"), isActive: false },
      { id: ShopProductCategory.FirstAid, text: t("category.firstAid"), isActive: false },
      { id: ShopProductCategory.Equipment, text: t("category.equipment"), isActive: false },
      { id: ShopProductCategory.Smartphone, text: t("category.smartphone"), isActive: false },
      { id: ShopProductCategory.Tablet, text: t("category.tablet"), isActive: false },
      { id: ShopProductCategory.Electronic, text: t("category.electronic"), isActive: false },
      { id: ShopProductCategory.Other, text: t("category.different"), isActive: false },
    ];

    const listAllId = listAll.map((item) => item.id);

    const resultArr: NavItemType[] = [{ id: "all", text: t("category.all"), isActive: true }];

    const uniqueList = Array.from(new Set(list.map((item) => item.category)));

    listAllId.forEach((id, idx) => {
      if (uniqueList.includes(id)) resultArr.push(listAll[idx]);
    });

    return resultArr;
  }, [list, t]);
}
